import { getServiceByCategory, categoryFieldName } from 'utils/helper/product';

export const initialState = (subscribedServices, allowableServices) => {
  const initialValues = {};
  if (subscribedServices.length > 0) {
    const services = getServiceByCategory({ services: allowableServices });
    services.forEach(service => {
      const { category } = service;
      const { allowableServices } = service;
      const found = allowableServices.filter(item =>
        subscribedServices.includes(item.id),
      );
      if (found) {
        initialValues[categoryFieldName(category)] = found.map(item => item.id);
      }
    });
  }

  return initialValues;
};
